import { isElectron } from "@/utils";

export const projectName = "AI模型应用管理中控平台";

const devBaseURL = "/dev-api";
const prodBaseURL = "/scc-api";
export const cozeBaseURL = "/coze";

export const env = process.env.VUE_APP_ENV;

export const baseURL =
  env === "development"
    ? devBaseURL
    : isElectron()
      ? `${env === "production" ? "http://scc.sourceaix.com" : "http://t-scc.sourceaix.com"}${prodBaseURL}`
      : prodBaseURL;

export const defaultTimeout = 5000;
